<script lang='ts'>
// import { useNavigate } from "svelte-navigator";
import {containFill, timeWindow} from '../util';
import MediaDesktop from './MediaDesktop.svelte';
import MediaMobile from './MediaMobile.svelte';

interface Indicator {
  x: number;
  y: number;
  label: string;
  path: string;
}

interface Tile {
  title: string;
  img: string;
  path: string;
}

export let indicators: Indicator[] = [];
export let tiles: Tile[] = [];
export let background;
export let forecolor = undefined;
export let backcolor = undefined;

let imageWidth;
let imageHeight;
let width;
let height;
let scale;

// const navigate = useNavigate();

function goLink(link) {
  if (link.startsWith("http")) {
    window.open(link, "_blank");
  } else {
    window.location.href = link;
    // navigate(link);
  }
}

function updateBackground() {
  const img = new Image();
  img.addEventListener('load', _ => {
    imageWidth = img.width;
    imageHeight = img.height;
  });
  img.src = background;
}

$: if (background) updateBackground();
$: if (width > 0 && height > 0) scale = containFill(imageWidth, imageHeight, width, height);

// onMount(() => {
//   const sub1 = timeWindow(new Date(`2022/02/16 17:00 EST`), new Date(`2022/02/17 12:00 EST`)).subscribe(enabled => {
//     if (enabled) {
//       indicators.push({id: 'vote', x: 300, y: 200, label: 'Vote!', path: 'https://app.sli.do/event/1Uo3LwPqRhWN7mEVxYgBoF', class: ''})
//       tiles.push({id: 'vote', title: 'VOTE!', img: '/img/mobile-vote.jpg', path: 'https://app.sli.do/event/1Uo3LwPqRhWN7mEVxYgBoF'})
//       indicators = indicators
//       tiles = tiles
//     } else {
//       indicators = indicators.filter(i => i.id !== 'vote')
//       tiles = tiles.filter(i => i.id !== 'vote')
//     }
//   });

//   const sub2 = timeWindow(new Date(`2022/02/16 17:00 EST`), new Date(`2022/02/17 17:00 EST`)).subscribe(enabled => {
//     if (enabled) {
//       indicators.push({id: 'concept', x: -650, y: -50, label: 'Concepts Gallery', path: 'https://iweek.parallel.live/iWeek 2022 - Concept Gallery.pdf', class: ''})
//       tiles.push({id: 'concept', title: 'CONCEPTS GALLERY', img: '/img/mobile-concepts.png', path: 'https://iweek.parallel.live/iWeek 2022 - Concept Gallery.pdf'})
//       indicators = indicators
//       tiles = tiles
//     } else {
//       indicators = indicators.filter(i => i.id !== 'concept')
//       tiles = tiles.filter(i => i.id !== 'concept')
//     }
//   });

//   return () => {
//     sub1.unsubscribe();
//     sub2.unsubscribe();
//   }
// })
</script>

<MediaDesktop>
  <div class="color centercenter" style={`--forecolor: ${forecolor || 'var(--text-secondary)'};--backcolor: ${backcolor || 'var(--secondary)'}`}>
    <div class="background" style="background-image: url({background})" bind:clientWidth={width} bind:clientHeight={height}>
      <div class="content">
        {#each indicators as i}
          <div class="indicator col hcenter" style="top:{scale * i.y}px;left: {scale * i.x}px" on:click={() => goLink(i.path)}>
            <div class="plus centercenter">
              <i class="material-icons">add</i>
            </div>

            <div class="label centercenter">{i.label}</div>
          </div>
        {/each}
      </div>
    </div>
  </div>
</MediaDesktop>

<MediaMobile>
  <div class="mobile col hcenter">
    {#each tiles as tile}
      <div on:click={() => goLink(tile.path)}>
        <div>{tile.title}</div>
        <!-- svelte-ignore a11y-missing-attribute -->
        <img src={tile.img} />
      </div>
    {/each}
  </div>
</MediaMobile>

<style lang="scss">
@import '../util';

.color {
  background-size: cover;
  background-color: white;
  flex: 1;
  height: 100%;

  @include landscape {
    display: none;
  }
}

.background {
  flex: 1;
  align-self: stretch;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-position: center center;
  position: relative;
}

.content {
  position: absolute;
  top: 50%;
  left: 50%;
}

.indicator {
  position: absolute;
  cursor: pointer;
  transform: translateX(-50%);
  background-repeat: no-repeat;
  background-size: contain;
  width: 310px;
  height: 96px;
}

.plus {
  @include shadow;
  display: flex;
  border-radius: 9999px;
  background-color: var(--backcolor);
  color: var(--forecolor);
  width: 36px;
  height: 36px;
}
.label {
  background-color: var(--backcolor);
  color: var(--forecolor);
  padding: 4px 16px;
  // border-radius: 5px;
  margin-top: 8px;
  font-weight: 500;
  white-space: nowrap;
  font-size: 22px;
  letter-spacing: 0.05em;
}

.mobile {
  display: none;
  flex-direction: column;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding: 16px 0;
  min-height: calc(100vh - 5rem);
  color: black;

  @include landscape {
    display: flex;
  }

  div {
    font-size: 24px;
    font-weight: 800;
    text-align: center;
    margin: 8px 0;
  }

  img {
    width: 100%;
    object-fit: contain;
  }
}
</style>